<template>
  <login-component-layout component="LoginCardForgotPassword">
    <div class="mb-6">
      <span>{{ $t("components.login.LoginCardForgotPassword.description") }}</span>
    </div>
    <v-form v-model="isFormValid" @submit.prevent="submit">
      <login-component-input-mail />
      <login-component-message :failText="failText" :successText="successText" />
      <login-component-submit-button
        :isLoading="isLoading"
        :isFormValid="!isButtonDisabled"
        component="LoginCardForgotPassword"
      />
      <login-component-navigation-button to="/login" :isDisabled="isFormSubmitted" />
    </v-form>
  </login-component-layout>
</template>

<script lang="ts">
import { Component, Mixins } from "vue-property-decorator";
import LoginMixin from "@/mixins/LoginMixin.vue";
import LoginComponentInputMail from "@/components/login/LoginComponentInputMail.vue";
import LoginComponentMessage from "@/components/login/LoginComponentMessage.vue";
import LoginComponentSubmitButton from "@/components/login/LoginComponentSubmitButton.vue";
import LoginComponentNavigationButton from "@/components/login/LoginComponentNavigationButton.vue";
import LoginComponentLayout from "@/components/login/LoginComponentLayout.vue";
import { UserModule } from "@/store/modules/me-user.store";
import LoginErrorMixin from "@/mixins/LoginErrorMixin.vue";

@Component({
  components: {
    LoginComponentInputMail,
    LoginComponentMessage,
    LoginComponentNavigationButton,
    LoginComponentSubmitButton,
    LoginComponentLayout
  }
})
export default class LoginCardForgotPassword extends Mixins(LoginMixin, LoginErrorMixin) {
  /**
   * Request password reset mail
   */
  async submit() {
    try {
      this.isFormSubmitted = true;
      this.isLoading = true;
      await UserModule.forgotPassword(this.mail);
      await this.handleSuccess("/login/reset");
    } catch (error) {
      this.handleFail(error);
    } finally {
      this.isLoading = false;
    }
  }
}
</script>

<style scoped>
.bold {
  font-weight: 900;
}
</style>
